import { useEffect, useState } from 'react';

export default function Modal({ children, onClose }) {
  const [closing, setClosing] = useState(false);

  // Prevent background scroll while modal is mounted
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  const startClose = () => {
    setClosing(true);
  };

  const handleAnimationEnd = (e) => {
    if (closing && e.animationName === 'modalOut') {
      if (typeof onClose === 'function') onClose();
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <style>{`
        @keyframes modalIn { from { transform: translateY(18px) scale(.98); opacity: 0 } to { transform: translateY(0) scale(1); opacity: 1 } }
        @keyframes modalOut { from { transform: translateY(0) scale(1); opacity: 1 } to { transform: translateY(18px) scale(.98); opacity: 0 } }
        @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
        @keyframes fadeOut { from { opacity: 1 } to { opacity: 0 } }
      `}</style>

      {/* backdrop */}
      <div
        onClick={startClose}
        style={{
          position: 'absolute',
          inset: 0,
          background: 'rgba(15, 18, 30, 0.58)',
          backdropFilter: 'blur(4px)',
          animation: closing ? 'fadeOut .18s ease' : 'fadeIn .18s ease',
        }}
      />

      {/* window */}
      <div
        role="dialog"
        aria-modal="true"
        onAnimationEnd={handleAnimationEnd}
        className="auth-modal__window"
        style={{
          animation: closing ? 'modalOut .18s ease' : 'modalIn .18s cubic-bezier(.2,.9,.3,1)',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '0.5rem 0.5rem 0 0' }}>
          <button aria-label="Close" onClick={startClose} className="auth-modal__close">
            ✕
          </button>
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
}
